// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"937":"c6916410","2506":"5547f192","4493":"2de00fff","9801":"86a6bf80"}[chunkId] + ".chunk.css";
};